import { useQuery } from "@apollo/client";
import { IShiftEntity } from "./ShiftEntityInterfaces";
import { useEffect, useState } from "react";
import { IShift } from "entities/Mills/MillsEntityInterfaces";
import { getAllShifts } from "api/queries/ShiftsAPI";

export const ShiftEntity: IShiftEntity = {
    GetShiftList: () => {
        const { data, error, loading, refetch } = useQuery(getAllShifts);
        const [shifts, setShifts] = useState<IShift[]>([]);

        useEffect(() => {
            if (data) {
                setShifts(data.shift);
            }
        }, [data]);

        return { error, shifts, loading, refetch };
    },
};
